// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7b70a4d7","455":"d412a6ee","977":"5f09ee5c"}[chunkId] + ".chunk.js";
};